// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';
import styled, { keyframes } from 'styled-components';

import WinaLoader from '../../../../components/WinaLoader';
import { __, getLang } from '../../../../i18n/l10n';
import { BoomAssetsBySkinId } from '../../constants/assets';
import BoomUIBySkinId from '../../constants/ui';
import { useBoomContext } from '../../contexts/BoomContext';
import BoomEnrollmentButtonContainer from '../BoomEnrollmentButton/BoomEnrollmentButtonContainer';
import BoomViewWrapper from '../BoomViewWrapper';
import BoomBoxWrapper from '../common/BoomBoxWrapper';

const APPEARANCE_ANIMATION_DURATION = 500;

const StyledBoomViewWrapper = styled(BoomViewWrapper)``;

const fadeInWithTranslationAnim = keyframes`
  0% {
    transform: translateY(-25%);
    opacity: 0;
  }

  20% {
    transform: translateY(-25%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const fadeInWithTranslationToTopAnim = keyframes`
  0% {
    transform: translateY(25%);
    opacity: 0;
  }

  20% {
    transform: translateY(25%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const Logo = styled.img`
  height: 12em;
  display: block;
  margin: 12em auto 0;

  animation: ${fadeInWithTranslationAnim} ${APPEARANCE_ANIMATION_DURATION}ms ease-in-out forwards;
`;

const MessageWrapper = styled(BoomBoxWrapper)`
  position: absolute;
  z-index: 2;
  bottom: 0.6em;
  left: 0.6em;
  right: 0.6em;

  animation: ${fadeInWithTranslationToTopAnim} ${APPEARANCE_ANIMATION_DURATION}ms ease-in-out forwards;
`;

const Message = styled.div`
  font-size: 1.3em;
  color: ${({ $skinId }) => BoomUIBySkinId[$skinId]?.ENROLLMENT_WINDOW_STYLE.messageTextColor};
  margin-bottom: 1em;
  white-space: pre-line;
`;

const StyledBoomEnrollmentButtonContainer = styled(BoomEnrollmentButtonContainer)`
  animation: ${fadeInWithTranslationAnim} ${APPEARANCE_ANIMATION_DURATION}ms ease-in-out forwards;
`;

const fadeInLoaderAnim = keyframes`
0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const StyledWinaLoader = styled(WinaLoader)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;

  animation: ${fadeInLoaderAnim} ${APPEARANCE_ANIMATION_DURATION / 2}ms ease-in-out forwards;
`;

type BoomEnrollmentProps = {
  className?: string;
  isPlayable: boolean;
};

const BoomEnrollment = ({ className, isPlayable }: BoomEnrollmentProps) => {
  const { skinId } = useBoomContext();
  const [hasBeenClicked, setHasBeenClicked] = useState(false);

  const onRegisterRequested = useCallback(() => {
    setHasBeenClicked(true);
  }, []);

  const onRegisterResponded = useCallback(() => {
    setHasBeenClicked(false);
  }, []);

  const srcLogo = useMemo(
    () => BoomAssetsBySkinId[skinId]?.Logo[getLang()] ?? BoomAssetsBySkinId[skinId]?.Logo?.Full,
    [skinId],
  );

  return (
    <StyledBoomViewWrapper className={className} $hasBeenClicked={hasBeenClicked}>
      <Logo src={srcLogo} />
      {isPlayable ? (
        <MessageWrapper $skinId={skinId}>
          <Message $skinId={skinId}>{__('Play the game to try and win a ton of Freebets!')}</Message>
          <StyledBoomEnrollmentButtonContainer
            onRegisterRequested={onRegisterRequested}
            onRegisterResponded={onRegisterResponded}
            delay={APPEARANCE_ANIMATION_DURATION}
            disabled={hasBeenClicked}
          />
        </MessageWrapper>
      ) : null}

      {hasBeenClicked ? <StyledWinaLoader /> : null}
    </StyledBoomViewWrapper>
  );
};

export default BoomEnrollment;
